import { type CustomTooltipProps } from "ag-grid-react"

import HeaderTooltip from "./HeaderTooltip"
import { SizeSplitGraph } from "../../graphs/SizeSplitGraph"
import { api } from "~/utils/api"
import { getStartOfCurrentWeekUTC } from "~/utils/datetime"
import { addDays } from "date-fns"
import { type IVariantSummary } from "~/hooks/useVariantTableData"
import { useChartSeriesConfig } from "~/constants/colors"
import { filterDefined } from "~/utils/tsUtils"

export default function StockStatusTooltip(
  props: CustomTooltipProps<IVariantSummary, IVariantSummary[]>,
) {
  const chartConfig = useChartSeriesConfig()

  if (props.location === "header") {
    return <HeaderTooltip {...props} />
  }

  const variants = props.node?.group
    ? props.node?.allLeafChildren?.map((x) => x.data)
    : [props.data]
  const variantIds = filterDefined(variants?.map((variant) => variant?.variantId))

  if (!variantIds?.length) return

  const { data } = api.product.getSizeSplitData.useQuery({
    variantIds,
    startDate: getStartOfCurrentWeekUTC(),
    endDate: addDays(getStartOfCurrentWeekUTC(), 364 - 1), // function does <= endDate, so 364-1 to get 52 weeks
  })

  const forecastGraphData = {
    name: "Demand",
    color: chartConfig.demand.color,
    dashStyle: chartConfig.demand.dashStyle,
    data: data?.forecasts ?? [],
  }

  const inventoryGraphData = {
    name: "Inventory",
    color: chartConfig.closingStock.color,
    dashStyle: chartConfig.closingStock.dashStyle,
    data: data?.stockLevels ?? [],
  }

  return (
    <div className="bg-base w-[600px] mr-6 z-10">
      <SizeSplitGraph
        series={[forecastGraphData, inventoryGraphData]}
        title="Size split (next 52 weeks)"
      />
    </div>
  )
}
